import React from "react";
import { getWindow } from "ssr-window";

import ContainerNavs from "@/react-components/ContainerNavs";
import ArticleTop from "@/react-components/ArticleTop";
import ArticleItem from "@/react-components/ArticleItem";
import EmptyResult from "@/react-components/EmptyResult";
import Pagination from "@/react-components/Pagination";
import { api } from "@/utils/api";
import url from "@/utils/url";
import { setUrlParameter } from "@/utils";

class ResearchInfoSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageParams: {
        catagoryid:
          getWindow()?.history?.state?.params?.catagoryid ||
          props?.router?.location?.state?.catagoryId,
        pageNo: getWindow()?.history?.state?.params?.pageNo || 1,
        pageSize: 9,
        totalPage: 1,
      },
      // 検索結果の保存
      articles: undefined,
      navList: [],
      // 検索アイコンの遷移URL
      icMenu: {
        url: url.researchSearch,
      },
    };
  }

  componentDidMount() {
    this.fetchTagList();
  }

  // get tag list
  fetchTagList = () => {
    api.dictionary
      .getTagFirstList()
      .then((response) => {
        const { pageParams } = this.state;
        this.setState(
          {
            navList: response.map((item, index) => {
              return {
                catagoryid: item.itemid,
                text: item.text,
                type:
                  index === 0
                    ? "business"
                    : index === 1
                    ? "economy"
                    : "industry",
              };
            }),
            pageParams: {
              ...pageParams,
              catagoryid: pageParams.catagoryid || response[0].itemid,
            },
          },
          () => {
            this.fetchData(this.state.pageParams);
          }
        );
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchData = (obj) => {
    const { navList } = this.state;
    const params = Object.assign(this.state.pageParams, obj);
    const state = getWindow()?.history?.state || {};
    state.params = params;
    getWindow().history.replaceState(state, "");
    api.report
      .getList(null, {
        catagoryID: params.catagoryid,
        pageIndex: params.pageNo,
        pageSize: params.pageSize,
      })
      .then((response) => {
        params.totalPage = parseInt(
          (response.totalCount + params.pageSize - 1) / params.pageSize
        );
        this.setState({
          pageParams: params,
          articles: response.list,
        });
        if (response.list.length === 0) {
          setUrlParameter({ type: "noResult" });
        } else {
          setUrlParameter({
            type: navList.find((item) => item.catagoryid === params.catagoryid)
              .type,
            page: params.pageNo,
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  pageChange = (page) => {
    this.fetchData({ pageNo: page });
  };

  render() {
    const { totalPage, catagoryid, pageNo } = this.state.pageParams;
    const { navList, icMenu, articles } = this.state;
    const activeIndex = navList
      .map((item) => item.catagoryid)
      .indexOf(catagoryid);
    return (
      <React.Fragment>
        {/* ヘッダ */}
        <ContainerNavs
          navs={navList}
          icMenus={icMenu}
          activeIndex={activeIndex}
          navChange={(catagoryId) =>
            this.fetchData({ catagoryid: catagoryId, pageNo: 1 })
          }
        />
        {articles && (
          <React.Fragment>
            {/* リサーチ情報の内容 */}
            {articles.map(
              (item, index) =>
                index === 0 && <ArticleTop key={index} articles={item} />
            )}
            <div className="news-section-content">
              {articles.map(
                (item, index) =>
                  index > 0 && <ArticleItem key={index} articles={item} />
              )}
            </div>
            {/* 改ページ */}
            {articles.length > 0 ? (
              <div className="pagination-container">
                <Pagination
                  totalPage={totalPage}
                  pageIndex={pageNo}
                  onChange={this.pageChange}
                />
              </div>
            ) : (
              // 検索結果なし
              <EmptyResult />
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default ResearchInfoSection;
